/** @module shop/star-rating */

import { liveEvents } from '../../../../../assets/js/application/index.js';

/**
 * Should not be referenced directly.
 * @private
 * @return {Promise<void>}
 */
export async function initStarRating() {
    const events = await liveEvents();

    events.addEventListener('[data-rating] input', 'change', ({ target }, selector) => {
        target
            .closest('[data-rating]')
            .querySelectorAll('label')
            .forEach((label) => {
                label.classList.remove('is-active');
            });

        if (target.closest(selector).value) {
            const label = target.closest('label');

            label.parentNode.classList.add('has-value');
            label.classList.add('is-active');
        }
    });
}
